import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11 17h2v-1h2v-5h-4v-1h4V8h-2V7h-2v1H9v5h4v1H9v2h2v1zM22 4H2.01L2 20h20V4zm-2 14H4V6h16v12z"
}), 'LocalAtmSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LocalAtmSharp.js
// module id = 4539
// module chunks = 2